import { Icon } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledIcon = styled(Icon) `
  flex: 0 0 auto;
  vertical-align: middle;
`;
